import React from "react";
import { getShipmentProgress } from "../../helper/shipmentProgress";

const ShipmentProgressCell = ({ row, tab }) => {
  const progress = getShipmentProgress(row, { tab });

  if (!progress) {
    return (
      <div className="shipment-progress-cell is-empty">
        Tracking data awaited
      </div>
    );
  }

  return (
    <div className={`shipment-progress-cell tone-${progress.tone}`}>
      <div className="shipment-progress-cell__track">
        <span
          className="shipment-progress-cell__fill"
          style={{ width: `${progress.percent}%` }}
        />
        <span
          className="shipment-progress-cell__marker"
          style={{ left: `${progress.percent}%` }}
        />
      </div>
      <div className="shipment-progress-cell__meta">
        <span className="shipment-progress-cell__milestone">
          {progress.startLabel}
        </span>
        <span className="shipment-progress-cell__status">
          {progress.statusLabel}
          {progress.percentLabel ? (
            <em className="shipment-progress-cell__percent">
              {progress.percentLabel}
            </em>
          ) : null}
        </span>
        <span className="shipment-progress-cell__milestone is-end">
          {progress.endLabel}
        </span>
      </div>
    </div>
  );
};

export default ShipmentProgressCell;
